// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2ybSr","bigColWidth":"Table_bigColWidth__3mqIr","biggerColWidth":"Table_biggerColWidth__SzGAi","row":"Table_row__1jHKU","col":"Table_col__rPswa"};